import { screen } from '~styles/metrics';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 399px;

  .column {
    margin-left: 12px;
  }

  @media ${screen.tablet} {
    padding: 0 18px;
  }
`;
